import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'get'

export default class OspreyContentBlocksSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'a83b67d3-a564-4fd4-8638-7fc62b80b0a3'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'created,id,modified,name,tags,contentBlocks,shareTo,statusType'
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-search.js